const normalizeParentIds = (parentIds) => {
  if (!parentIds) return [];
  const list = Array.isArray(parentIds) ? parentIds : [parentIds];
  return list
    .filter((id) => id != null && id !== '')
    .map((id) => String(id));
};

/**
 * Filtra opções de catálogo (ex.: NSIR_SUBTIPOS) pelo parentId do tipo de serviço.
 * Sem parentId/parentIds, retorna a lista completa (retrocompatível).
 */
export const filterOptionsByParentId = (options, { parentId, parentIds } = {}) => {
  if (!options?.length) return [];

  const parents =
    parentId != null && parentId !== ''
      ? [String(parentId)]
      : normalizeParentIds(parentIds);

  if (parents.length === 0) return options;

  return options.filter((option) => {
    if (option.parentId == null || option.parentId === '') return false;
    return parents.includes(String(option.parentId));
  });
};
